"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _typography = require("../typography");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AppInfoList = /*#__PURE__*/function (_React$Component) {
  _inherits(AppInfoList, _React$Component);

  function AppInfoList() {
    _classCallCheck(this, AppInfoList);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppInfoList).apply(this, arguments));
  }

  _createClass(AppInfoList, [{
    key: "_getTitle",
    value: function _getTitle() {
      if (!this.props.title) return null;
      var icon = this.props.icon;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("h4", null, icon ? _react["default"].createElement(_typography.AppIcon, {
        icon: icon
      }) : null, " ", this.props.title), _react["default"].createElement("hr", null));
    }
  }, {
    key: "_getItems",
    value: function _getItems() {
      var items = this.props.items;
      var itemElements = [];
      items.forEach(function (element, index) {
        itemElements.push(_react["default"].createElement(_react["default"].Fragment, {
          key: index
        }, _react["default"].createElement("dt", null, element.label), _react["default"].createElement("dd", null, element.value)));
      });
      return _react["default"].createElement("dl", null, itemElements);
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(_react["default"].Fragment, null, this._getTitle(), this._getItems());
    }
  }]);

  return AppInfoList;
}(_react["default"].Component);

exports["default"] = AppInfoList;